import { AsyncActions } from '../../standard-actions/';

export const CASE_NEW = 'New';
export type CASE_NEW = 'New';
export const CASE_IN_PROGRESS = 'In Progress';
export type CASE_IN_PROGRESS = 'In Progress';
export const CASE_ON_HOLD = 'On Hold';
export type CASE_ON_HOLD = 'On Hold';
export const CASE_WITHDRAWN = 'Withdrawn';
export type CASE_WITHDRAWN = 'Withdrawn';
export const CASE_REJECTED = 'Rejected';
export type CASE_REJECTED = 'Rejected';
export const CASE_CLOSED = 'Closed';
export type CASE_CLOSED = 'Closed';
export const CASE_RESOLVED = 'Resolved';
export type CASE_RESOLVED = 'Resolved';

export type ICaseStatus = | CASE_NEW | CASE_IN_PROGRESS | CASE_ON_HOLD | CASE_WITHDRAWN
| CASE_REJECTED | CASE_CLOSED;

export enum CasesTableFields {
    CaseId = 'caseId',
    Status = 'status',
    Category = 'category',
    Description = 'description',
    SubStatus = 'subStatus',
    SubmittedBy = 'submittedBy',
    DateSubmitted = 'dateSubmitted',
    BillingAccountNumber = 'billingAccountNumber',
    ServiceFnn = 'serviceFnn'
}

export interface ICase {
    [CasesTableFields.CaseId]: string;
    [CasesTableFields.Category]: string;
    [CasesTableFields.Description]: string;
    [CasesTableFields.Status]: ICaseStatus;
    [CasesTableFields.SubStatus]: ICaseStatus | string;
    [CasesTableFields.DateSubmitted]: string;
    [CasesTableFields.SubmittedBy]: string;
    [CasesTableFields.BillingAccountNumber]: string;
    [CasesTableFields.ServiceFnn]: string;
    caseType: string;
}

export interface ICasesResponse {
    cases: ICase[];
    original_cases: ICase[];
    fetchTime: number;
}

export interface ILoadCasesRequest {
    data: ICasesResponse;
    status: AsyncActions.AsyncActionState;
    error?: string;
    filter?: ISearchFilter;
    selectedCompanyId?: string;
}

export interface ISearchFilter {
    submittedBy?: string[];
    assignedTo?: string[];
}

export interface ISelectedFilters {
    status: string[]
    assignedTo: string[],
    dates: string[]
    selectedDateInput: string[],
    submittedBy: string[],
    searchText?: string,
}
